import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Table from "../../Table";
import {
  deleteCart,
  fetchAllCarts,
} from "../../../../redux/reducer/cartReducer";
import DetailsCartTable from "./DetailsCartTable";
import BoxEmpty from "../../../boxDetials/boxEmpty";
import LoadingSpinner from "../../../animation/LoadingSpinner";

const PurchasedCart = () => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [editingProducts, setEditingProducts] = useState(null);
  const dispatch = useDispatch();
  const { allCarts, loading, error } = useSelector((state) => state.carts);
  const { t } = useTranslation();
  const [searchBox, setSearchBox] = useState("");
  const headers = [
    "ID",
    "Box. No",
    "Name",
    "Phone",
    "Status",
    "Area",
    // 'Notes',
    "Check Order",
    "Created At",
    "Fees_prod",
    "Pric_Prod",
    "Fees Mar_Shp",
    "Tot_Cart",
    "Actions",
    "Products",
  ];

  const refreshData = () => {
    dispatch(fetchAllCarts(["purchased"]));
  };

  useEffect(() => {
    dispatch(fetchAllCarts(["purchased"]));
  }, [dispatch]);

  const handleDelete = (cartId) => {
    if (window.confirm("Are you sure you want to delete this Cart?")) {
      dispatch(deleteCart(cartId))
        .unwrap()
        .then(() => {
          dispatch(fetchAllCarts(["purchased"]));
        })
        .catch((error) => alert(error || "Failed to delete Cart."));
    }
  };

  const handleUpdate = () => {
    dispatch(fetchAllCarts(["purchased"]));
  };
  const purchasedCartsBefore = allCarts.filter(
    (cart) => cart.status === "purchased"
  );
  const purchasedCarts = allCarts
    .filter((cart) => cart.status === "purchased")
    .filter((cart) =>
      cart.referenceCode?.toLowerCase().includes(searchBox.toLowerCase())
    );
  // console.log(purchasedCarts)

  if (loading && purchasedCartsBefore.length === 0) {
    return <LoadingSpinner />;
  }

  if (purchasedCartsBefore.length === 0) {
    return <BoxEmpty title="Not Found Orders" />;
  }

  return (
    <Table
      title={t("Purchased Orders")}
      headers={headers}
      data={purchasedCarts}
      searchBox={searchBox}
      setSearchBox={setSearchBox}
      renderRow={(cart, index) => (
        <DetailsCartTable
          key={cart._id || index}
          index={index + 1}
          details={{
            id: cart._id,
            number: index + 1,
            boxNumber: cart.referenceCode,
            Name: cart.user?.name,
            phone: cart.user?.phone,
            countryCode: cart.user?.countryCode,
            status: cart.status,
            note: cart.notesAdmin,
            history: cart.createdAt,
            products: cart.products,
            DShippingFees: cart.totalDShippingFees,
            markaShipFees: cart.markaShipFees,
            paymentStatus: cart.paymentStatus,
            timeLeft: cart.timeLeft,
            totalCartPrice: cart.totalCartPrice,
            totalCartPriceBeforeFees: cart.totalCartPriceBeforeFees,
            area: cart.area,
            isCheck: cart.isCheck,
            paymentPDF: cart.paymentPDF,
          }}
          isEditing={editingOrder === cart._id}
          setEditingOrder={setEditingOrder}
          isProducts={editingProducts === cart._id}
          setEditingProducts={setEditingProducts}
          onDelete={() => handleDelete(cart._id)}
          onUpdate={handleUpdate}
          refreshData={refreshData}
          loading={loading}
        />
      )}
    />
  );
};

export default PurchasedCart;
